import type { DomainState } from '@prerender/diagnostics-api';

const DOMAIN_STATE_LABELS: Record<DomainState, string> = {
  affected: 'Affected',
  no_longer_affected: 'No longer affected',
  affected_when_closed: 'Affected when closed',
};

export function domainStateLabel(state: DomainState): string {
  return DOMAIN_STATE_LABELS[state];
}
